import {
  NYTIMES,
  WWD,
  TODAY,
  ABC,
  FORBES,
  GLAMOUR,
  BEAUTY_MATTER,
  ELLE,
  MODERN_LUXARY,
  PR_NEWSWIRE,
  THE_TEASE,
  YAHOO_FINANCE,

  ARTICLE20200701,
  ARTICLE20200201,
  ARTICLE20200202,
  ARTICLE20191201,
  ARTICLE20191001,
  ARTICLE20191002,
  ARTICLE20250301,
  ARTICLE20241001,
  ARTICLE20240801,
  ARTICLE20240701,
  ARTICLE20240601,
  ARTICLE20240501,
  ARTICLE20230101,
  ARTICLE20230102,
} from '../../../public/press'

export const data = [
  {
    date: 'March 2025',
    route: '20250301',
    href: 'https://digital.modernluxury.com/publication/?i=841385&p=38&view=issueViewer',
    logo: MODERN_LUXARY,
    alt: 'Modern Luxary',
    images: ARTICLE20250301
  },
  {
    date: 'October 2024',
    route: '20241001',
    href: 'https://uk.finance.yahoo.com/news/coming-off-very-public-breakup-161000460.html?guccounter=1&guce_referrer=aHR0cHM6Ly93d3cuZ29vZ2xlLmNvbS8&guce_referrer_sig=AQAAAHp55w82rBhw7VeJ9CifqrcB4scBlJkHLFEmOCxPH9J64cgfmVfto0vNmJij1Xx19_PbISCw8O8R4_ETjOa7w0Zeg3U3hur01w4xo_8PSaLbQrOunSQGJCneWD_ORD_tUJmJP88x17OunyJIUKdbMDBI1EwZnY9B327DFrAR1ND1',
    logo: YAHOO_FINANCE,
    alt: 'Yahoo Finance',
    images: ARTICLE20241001
  },
  {
    date: 'August 2024',
    route: '20240801',
    href: 'https://www.thetease.com/shark-beauty-debuts-the-speedstyle-pro-and-speedstyle-proflex-along-with-an-exciting-new-partnership-with-glamsquad/',
    logo: THE_TEASE,
    alt: 'The Tease',
    images: ARTICLE20240801
  },
  {
    date: 'July 2024',
    route: '20240701',
    href: 'https://www.prnewswire.com/news-releases/kristin-ess-hair-aligns-with-glamsquad-as-their-preferred-hair-partner-302201733.html#:~:text=Glamsquad%20clientele%20across%20the%20country,and%20off%20the%20red%20carpet.',
    logo: PR_NEWSWIRE,
    alt: 'PR Newswire',
    images: ARTICLE20240701 
  },
  {
    date: 'June 2024',
    route: '20240601',
    href: 'https://finance.yahoo.com/news/clairol-partners-glamsquad-launch-house-130300318.html?guccounter=1&guce_referrer=aHR0cHM6Ly93d3cuZ29vZ2xlLmNvbS8&guce_referrer_sig=AQAAAHp55w82rBhw7VeJ9CifqrcB4scBlJkHLFEmOCxPH9J64cgfmVfto0vNmJij1Xx19_PbISCw8O8R4_ETjOa7w0Zeg3U3hur01w4xo_8PSaLbQrOunSQGJCneWD_ORD_tUJmJP88x17OunyJIUKdbMDBI1EwZnY9B327DFrAR1ND1',
    logo: YAHOO_FINANCE,
    alt: 'Yahoo Finance',
    images: ARTICLE20240601 
  },
  {
    date: 'May 2024',
    route: '20240501',
    href: 'https://www.elle.com/fashion/shopping/g42244898/gifts-for-mom/',
    logo: ELLE,
    alt: 'Elle',
    images: ARTICLE20240501
  },
  {
    date: 'January 2023',
    route: '20230101',
    href: 'https://wwd.com/beauty-industry-news/beauty-features/glamsquad-us-makeup-hair-national-investment-boathouse-1235468608/',
    logo: WWD,
    alt: 'WWD',
    images: ARTICLE20230101 
  },
  {
    date: 'January 2023',
    route: '20230102',
    href: 'https://beautymatter.com/articles/glamsquad-lands-minority-investment-from-boathouse-capital',
    logo: BEAUTY_MATTER,
    alt: 'Beauty Matter',
    images: ARTICLE20230102
  },
  {
    date: 'July 2020',
    route: '20200701',
    href: 'https://www.nytimes.com/2020/07/23/style/coronavirus-manicures-haircuts-tattoos-dog-groomer-at-home.html',
    logo: NYTIMES,
    alt: 'New York Times',
    images: ARTICLE20200701
  },
  {
    date: 'February 2020',
    route: '20200201',
    href: 'https://www.today.com/shop/watch-these-best-friends-36-years-experience-remarkable-ambush-makeover-t173307',
    logo: TODAY,
    alt: 'Today',
    images: ARTICLE20200201
  },
  {
    date: 'February 2020',
    route: '20200202',
    href: 'https://abc7ny.com/oscars-red-carpet-academy-awards-oscar/5904423/',
    logo: ABC,
    alt: 'ABC',
    images: ARTICLE20200202
  },
  {
    date: 'December 2019',
    route: '20191201',
    href: 'https://www.forbes.com/sites/jqlouise/2019/12/01/cyber-monday-deals-for-the-traveler/?sh=6a5f6b422a0c',
    logo: FORBES,
    alt: 'Forbes',
    images: ARTICLE20191201
  },
  {
    date: 'October 2019',
    route: '20191001',
    href: 'https://www.glamour.com/story/professional-halloween-makeup',
    logo: GLAMOUR,
    alt: 'Glamour',
    images: ARTICLE20191001
  },
  {
    date: 'October 2019',
    route: '20191002',
    href: 'https://www.today.com/video/last-minute-halloween-makeup-ideas-72449093619',
    logo: TODAY,
    alt: 'Today',
    images: ARTICLE20191002
  }
]
